import styled from "@emotion/styled";
import {
	Autocomplete,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
	alpha,
} from "@mui/material";
import config from "../../hoa-config";

import React from "react";

const InputTextFeild = styled(TextField)(({ theme, error }: any) => ({
	"& .MuiFilledInput-root": {
		border: !error ? "1px solid #e2e2e1" : "1px solid #FF0000",
		overflow: "hidden",
		borderRadius: 4,
		backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
		transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
		"&:hover": {
			backgroundColor: "transparent",
		},
		"&.Mui-focused": {
			backgroundColor: "transparent",
			boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
			borderColor: "#0000ff",
		},
	},
}));

export const TextFieldComponent = ({ title, onChangeText, options, value }: any) => (
	<div
		key={title}
		style={{
			width: "calc(100% - 48px)",
			borderBottom: "1px solid  #F7F7F7",
			marginTop: "24px",
		}}
	>
		<div className="advance-filter-container-single">
			<span
				className="filter-field-title-comp"
				style={{ margin: "2px", width: "85px", wordBreak: "break-word" }}
			>
				{title}
			</span>
			<InputTextFeild
				style={{ width: "184px", margin: "2px", marginLeft: "38px" }}
				label={title}
				InputProps={{ disableUnderline: true }}
				variant="filled"
				value={options[value] || ""}
				name={value}
				onChange={onChangeText}
			/>
		</div>
	</div>
);

export const OrgDropDown = ({ title, onChangeText, options }: any) => {
	return (
		<div
			key={title}
			style={{
				width: "calc(100% - 48px)",
				borderBottom: "1px solid  #F7F7F7",
				padding: "24px 0px",
				display: "flex",
				alignItems: "center",
				gap: "32px",
			}}
		>
			<span
				className="filter-field-title-comp"
				style={{ margin: "2px", width: "85px", wordBreak: "break-all" }}
			>
				{title}
			</span>
			<FormControl>
				<Autocomplete
					ListboxProps={{ style: { maxHeight: "200px" } }}
					style={{ width: "184px", margin: "2px" }}
					disableClearable
					disablePortal
					value={
						config.hoaOrganizations.find(
							(org: any) => org.id === options.organizationId
						) || null
					}
					options={config.hoaOrganizations}
					getOptionLabel={(option) => option.name}
					isOptionEqualToValue={(option, value) => option.id === value.id}
					onChange={(e, v) => {
						if (v !== null) {
							onChangeText({ target: { name: "organizationId", value: v.id } });
						}
					}}
					renderInput={(params: any) => (
						<TextField {...params} label="Organization Name" name="organizationId" />
					)}
				/>
			</FormControl>
		</div>
	);
};

export const RadioGroupComponent = ({
	title,
	onChangeText,
	options,
	value,
	radioOptions = [
		{ value: "mail", label: "Mail" },
		{ value: "email", label: "Email" },
	],
}: any) => (
	<div
		key={title}
		style={{
			width: "calc(100% - 48px)",
			borderBottom: "1px solid  #F7F7F7",
			marginTop: "24px",
		}}
	>
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
				marginBottom: "23px",
				alignItems: "center",
			}}
		>
			<span
				className="filter-field-title-comp"
				style={{ margin: "2px", width: "85px", wordBreak: "break-word" }}
			>
				{title}
			</span>
			<div>
				<FormControl>
					<RadioGroup name={value} value={options[value] || ""} onChange={onChangeText}>
						{radioOptions.map((option: any) => (
							<FormControlLabel
								key={option.value}
								value={option.value}
								control={<Radio />}
								label={option.label}
							/>
						))}
					</RadioGroup>
				</FormControl>
			</div>
		</div>
	</div>
);
